import React, { useState } from "react";
import { TabsContent } from "../../components/misc/Tabs";
import { Label } from "../../components/misc/Label";
import { Switch } from "../../components/misc/Switch";
import ReconfirmOverlay from "../../components/misc/ReconfirmOverlay";
import { User } from "../types";

interface EditUserRoleProps {
    userData: Partial<User> | null;
    setUserData: React.Dispatch<React.SetStateAction<Partial<User> | null>>;
}

const EditUserRole: React.FC<EditUserRoleProps> = ({ userData, setUserData }) => {
    const [guardOpen, setGuardOpen] = useState(false);
    const [pendingRole, setPendingRole] = useState<"ADMIN" | "CREATOR" | null>(null);

    const handleSwitchChange = (role: "ADMIN" | "CREATOR" | null) => {
        setPendingRole(role);
        setGuardOpen(true);
    };

    const handleProceed = () => {
        setUserData({
            ...userData,
            adminRole: pendingRole,
            isAdmin: pendingRole === "ADMIN",
        });
        setGuardOpen(false);
        setPendingRole(null);
    };

    const handleCancel = () => {
        setGuardOpen(false);
        setPendingRole(null);
    };

    return (
      <TabsContent value="userRole" className="w-full">

        <div className="mt-4 space-y-4">
          <div className="flex flex-row justify-between items-center w-full">
            <Label
              htmlFor="creatorApproved"
              className="text-primary flex flex-col space-y-1 font-semibold"
            >
              <span>Creator Approved</span>
              <span className="text-black font-normal text-sm text-muted-foreground">
                 Grants access to the impersonation feature, without administrative privileges.
              </span>
            </Label>
            <Switch
             id="creatorApproved"
              checked={userData?.adminRole === "CREATOR"}
              onCheckedChange={(checked) => {
                if (checked) {
                  handleSwitchChange("CREATOR");
                } else {
                  handleSwitchChange(null);
                }
              }}
            />
          </div>

          <div className="flex flex-row justify-between items-center w-full">
            <Label
             htmlFor="adminApproved"
             className="text-primary flex flex-col space-y-1 font-semibold"
            >
              <span>Admin Approved</span>
              <span className="text-black font-normal text-sm text-muted-foreground">
                 Grants complete access to all application features and administrative controls.
              </span>
            </Label>
            <Switch
              id="adminApproved"
              checked={userData?.adminRole === "ADMIN" || userData?.isAdmin === true || userData?.isAdmin === "true"}
              onCheckedChange={(checked) => {
                if (checked) {
                  handleSwitchChange("ADMIN");
                } else {
                  handleSwitchChange(null);
                }
              }}
            />
          </div>
        </div>

        {/* Guard Dialog */}
        <ReconfirmOverlay
          isOpen={guardOpen}
          title="Change User Role"
          message={
            pendingRole
              ? `Are you sure you want to set role to "${pendingRole}"?`
              : "Are you sure you want to remove the role?"
          }
          confirmText={pendingRole ? "Proceed" : "Proceed"}
          cancelText="Cancel"
          onClose={handleCancel}
          onConfirm={handleProceed}
        />
      </TabsContent>
    );
};

export default EditUserRole;
